"use client";

export function ControlsSubsectionLabel({
  children,
  trailing,
  className = "",
}: {
  children: React.ReactNode;
  trailing?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center justify-between text-[11px] text-[var(--color-fg-muted)] ${className}`}
    >
      <span>{children}</span>
      {trailing}
    </div>
  );
}
